<template>
  <div id="app">
    <banner />
    <div class="section">
      <search />
    </div>
    <page-footer />
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
// import Index from "./pages/Index.vue";
import Search from "./pages/Search.vue";
import PageFooter from "./components/PageFooter.vue";
export default {
  name: "App",
  components: {
    Banner,
    PageFooter,
    // Index,
    Search,
  },
};
</script>
<style>
.section {
  width: 90%;
  margin-left: 5%;
}
</style>